import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
    projectName: string;
}

@Component({
    selector: 'project-name-dialog',
    templateUrl: 'project-name-dialog.component.html',
    styleUrls: ['project-name-dialog.component.css']
})
export class ProjectNameDialog {

    constructor(
        public dialogRef: MatDialogRef<ProjectNameDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
        console.log("projectName: " + data.projectName);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
    onSubmitClick(): void {
        this.dialogRef.close(this.data.projectName);
    }


}
